module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [(!_vm.isLoading && _vm.$route.name === 'SettingsMedication') ? _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle boldTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-list', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('mu-card-text', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "to": {
        'name': 'SettingsAddMedications'
      },
      "rippleColor": "#F6F6F6",
      "fullWidth": "",
      "label": _vm.$t('message.medicationPreferencesAdd'),
      "secondary": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.medications.length > 0) ? _c('div', [_vm._l((_vm.activeMedications), function(item, index) {
    return _c('mu-list-item', {
      key: 'medication-active-' + index,
      class: {
        odd: index % 2 === 0
      },
      attrs: {
        "disableRipple": "",
        "title": item.treatment_name,
        "describeText": item.defaultDosage + ' ' + item.unit_label + ' ' + item.frequency_label.toLowerCase()
      }
    }, [_c('mu-icon-menu', {
      attrs: {
        "slot": "right",
        "anchorOrigin": _vm.rightTop,
        "targetOrigin": _vm.rightTop,
        "scroller": _vm.scroller,
        "icon": "more_vert",
        "desktop": ""
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "leftIcon": "edit",
        "title": _vm.$t('message.editText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editMedication(item)
        }
      }
    }), _vm._v(" "), (item.active === true) ? _c('mu-menu-item', {
      attrs: {
        "leftIcon": "visibility_off",
        "title": _vm.$t('message.disableText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.disableMedication(item)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), (item.editMode) ? _c('div', {
      attrs: {
        "slot": "default"
      },
      slot: "default"
    }) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.inActiveMedications.length > 0) ? _c('mu-content-block', {
    staticStyle: {
      "border-left": "4px solid #3d8517"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.medicationsPreferencesNotTaking')) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.inActiveMedications), function(item, index) {
    return _c('mu-list-item', {
      key: 'medication-inactive-' + index,
      class: {
        odd: index % 2 === 0
      },
      attrs: {
        "disableRipple": "",
        "title": item.treatment_name,
        "describeText": item.defaultDosage + ' ' + item.unit_label + ' ' + item.frequency_label.toLowerCase()
      }
    }, [_c('mu-icon-menu', {
      attrs: {
        "slot": "right",
        "anchorOrigin": _vm.rightTop,
        "targetOrigin": _vm.rightTop,
        "scroller": _vm.scroller,
        "icon": "more_vert",
        "desktop": ""
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "leftIcon": "edit",
        "title": _vm.$t('message.editText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editMedication(item)
        }
      }
    }), _vm._v(" "), (item.active === false) ? _c('mu-menu-item', {
      attrs: {
        "leftIcon": "visibility",
        "title": _vm.$t('message.enableText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.enableMedication(item)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), (item.editMode) ? _c('div', {
      attrs: {
        "slot": "default"
      },
      slot: "default"
    }) : _vm._e()], 1)
  })], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e28b0b40","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/Medications.vue
// module id = 3855
// module chunks = 1